const postDimensions = {
  desktopNewsFeed: { width: 680, height: 139 },
  desktopTimeline: { width: 500, height: 139 },
  mobileSingle: { width: 375, height: 139 },
}

const renderDisplayLayout = {
  mobileSingle: {
    minHeight: postDimensions.mobileSingle.height,
    width: postDimensions.mobileSingle.width,
  },
  desktopTimeline: {
    minHeight: postDimensions.desktopTimeline.height,
    width: postDimensions.desktopTimeline.width,
  },
  desktopNewsFeed: {
    minHeight: postDimensions.desktopNewsFeed.height,
    width: postDimensions.desktopNewsFeed.width,
  },
}

const baseStyles = (display) => ({
  ...renderDisplayLayout[display],
  backgroundColor: 'white',
  borderRadius: '4px',
  display: 'flex',
  flexDirection: 'column',
})

export { baseStyles }
